import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { useModuloInfo } from "../../../Context/ModuloInfo";

import {
    ListarEtapasAssistenciaTecnicaController,
    ListarEtapasAtendimentoAoClienteController,
    ListarEtapasEntregaDeChavesController,
    ListarEtapasRepasseController,
    ListarEtapasVendasController,
} from "../../../Controllers/Geral/Etapas/EtapasControllers";
import { IEtapa } from "../../../Interfaces/Geral/Etapas/EtapasInterfaces";
import { TModulo } from "../../../Interfaces/Utils/Modulo/ModuloInterfaces";

import "./styles.css";

type TModuloComEtapas = Extract<
    TModulo,
    "Atendimento" | "Assistencia" | "Repasse" | "EntregaChaves" | "Vendas"
>;
type IEtapasProps = {
    ID_ETAPA: number;
    gestao?: boolean;
    ID_CATEGORIA: number;
    finalizado?: boolean;
};

const TIPO_CASO = {
    Atendimento: {
        Listar: ListarEtapasAtendimentoAoClienteController,
    },
    Assistencia: {
        Listar: ListarEtapasAssistenciaTecnicaController,
    },
    Repasse: {
        Listar: ListarEtapasRepasseController,
    },
    EntregaChaves: {
        Listar: ListarEtapasEntregaDeChavesController,
    },
    Vendas: {
        Listar: ListarEtapasVendasController,
    },
};

/**
 * @param props.ID_ETAPA - etapa atual do atendimento
 * @returns componente que mostra as etapas da categoria de atendimento,
 * indicando em qual etapa o atendimento está
 */
export default function Etapas(props: IEtapasProps) {
    const [etapas, setEtapas] = useState<Array<IEtapa>>([]);
    const DS_MODULO = useModuloInfo().DS_MODULO as TModuloComEtapas;

    useEffect(() => {
        if ((props.ID_CATEGORIA || DS_MODULO !== "Atendimento") && DS_MODULO) {
            TIPO_CASO[DS_MODULO]?.Listar(props.ID_CATEGORIA).then((res) => {
                res.sort(
                    (a, b) =>
                        a.NR_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO -
                        b.NR_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO
                );
                setEtapas(res);
            });
        }
    }, [DS_MODULO, props.ID_CATEGORIA]);

    return etapas.length ? (
        <div
            className={`col-12 card card-custom pt-3 pb-0 ${
                props.finalizado ? "atendimento-finalizado" : ""
            }`}
        >
            <ul className="nav nav-pills nav-success row row-paddingless flex-column flex-nowrap flex-sm-row custom-scroll pb-2 etapas">
                {etapas.map((etapa) => (
                    <li
                        className={`d-flex col-sm flex-grow-1 flex-shrink-0 mb-3 mb-lg-0 etapa ${
                            etapa.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO ===
                            props.ID_ETAPA
                                ? "etapa-atual"
                                : ""
                        }`}
                        key={etapa.ID_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO}
                    >
                        <span
                            className={`border p-1 pt-2 d-flex flex-grow-1 rounded flex-column align-items-center`}
                        >
                            <span className="font-size-h5">
                                {etapa.NR_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO}
                            </span>
                            <span className="py-1 font-weight-bold text-center">
                                {etapa.DS_ETAPA_CATEGORIA_ATENDIMENTO_TIPO_CASO}
                                {props.gestao && (
                                    <div
                                        role="button"
                                        className="d-flex d-sm-none text-primary text-hover-info"
                                    >
                                        <FontAwesomeIcon icon={faEdit} />
                                    </div>
                                )}
                            </span>
                        </span>
                    </li>
                ))}
            </ul>
        </div>
    ) : (
        <></>
    );
}
